import { render } from "./NotificationBatchChangeFolder.vue?vue&type=template&id=a2e50eac&scoped=true&ts=true"
import script from "./NotificationBatchChangeFolder.vue?vue&type=script&lang=ts"
export * from "./NotificationBatchChangeFolder.vue?vue&type=script&lang=ts"

import "./NotificationBatchChangeFolder.vue?vue&type=style&index=0&id=a2e50eac&scoped=true&lang=css"

import exportComponent from "D:\\Ventla Code\\New Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2e50eac"]])

export default __exports__